import { Avatar } from '@dtx-company/design-system/src/components/Avatar/Avatar'
import { Box, Text } from '@dtx-company/shared-components/src'
import { Team, TeamMember } from '../../../components/FlowTeams/FlowTeams.types'
import { useNameParts } from '../FlowTeams.hooks'
import React, { useMemo } from 'react'

export const Name: React.FC<{ nameParts: { text: string; highlight: boolean }[] }> = ({
  nameParts
}) => {
  return (
    <>
      {nameParts.map((part, index) => (
        <span key={index} style={{ fontWeight: part?.highlight ? 'bold' : 'normal' }}>
          {part.text}
        </span>
      ))}
    </>
  )
}

export const MemberNameWithInitials: React.FC<{ member: TeamMember; boldSubstring?: string }> = ({
  member,
  boldSubstring
}) => {
  const showInvitationStyles = !member.hasBeenInvited || !member.hasJoinedOrg
  const name = useMemo(() => {
    if (member?.name) {
      return member?.name
    }
    if (member?.email) {
      return member?.email
    }
    return ''
  }, [member])
  const nameParts = useNameParts(name, boldSubstring)
  return (
    <Box
      display="flex"
      width="90%"
      alignItems="center"
      style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
    >
      <Avatar
        alt={member.name || member.email || 'avatar'}
        disabled={showInvitationStyles}
        src={member?.profilePictureUrl}
        data-testid="initials-container"
      />
      <Box display="flex" flexDirection="column" ml="8px">
        <Box width="100%" display="table" style={{ tableLayout: 'fixed' }}>
          <Text
            data-testid="name"
            display="table-cell"
            style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
            fontSize="14px"
            color={showInvitationStyles ? 'secondary.disabled' : 'primary.black'}
          >
            <Name nameParts={nameParts} />
          </Text>
        </Box>
        {member.name && member.email && (
          <Text data-testid="member-email" color="primary.grey" fontSize="12px">
            {member.email}
          </Text>
        )}
      </Box>
    </Box>
  )
}

export const TeamNameWithInitials: React.FC<{ team: Team; boldSubstring?: string }> = ({
  team,
  boldSubstring
}) => {
  const nameParts = useNameParts(team?.name ?? '', boldSubstring)
  return (
    <Box display="flex" width="100%" alignItems="center">
      <Avatar
        alt={team.name || 'team-avatar'}
        src={team?.profilePictureUrl}
        data-testid="initials-container"
      />
      <Box display="flex" flexDirection="column" ml="8px">
        <Text data-testid="name" fontSize="14px">
          <Name nameParts={nameParts} />
        </Text>
      </Box>
    </Box>
  )
}
